const scrollTo = (htmlEl, offset = 0) => {
  if (!htmlEl) throw new Error('Ожидался ref')

  window.scrollTo({
    top: window.scrollY + htmlEl.getBoundingClientRect().top - offset,
    behavior: 'smooth',
  })
  // htmlEl.scrollIntoView({
  //   behavior: 'smooth',
  // })
}

export default scrollTo
